import { DefaultRootStateProps } from 'types';
import { createSlice } from '@reduxjs/toolkit';
import { Meeting } from 'types/meeting';
import { dispatch } from 'store';
import axios from 'utils/axios';

const initialState: DefaultRootStateProps['meeting'] = {
  error: null,
  meeting: null,
  loading: false,
  loadingData: false,
  addedMeeting: null
};

const slice = createSlice({
  name: 'meeting',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },

    postMeetingSuccess(state, action) {
      state.addedMeeting = action.payload;
    },

    setLoading(state, action) {
      state.loading = action.payload;
    },

    setLoadingData(state, action) {
      state.loadingData = action.payload;
    },

    cleanMeetingState() {
      return initialState;
    }
  }
});

export default slice.reducer;

export function postMeeting(meeting: Meeting) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.post('/api/andevos/meetingRequests', meeting);
      dispatch(slice.actions.postMeetingSuccess(response.data));
      dispatch(slice.actions.setLoading(false));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(slice.actions.setLoading(false));
    }
  };
}

export function cleanMeetingState() {
  return async () => {
    dispatch(slice.actions.cleanMeetingState());
  };
}
